import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MembershipFeatureKey } from './membership-feature-key';
import { MembershipState } from './membership.state';

export const MembershipFeatureSelector =
  createFeatureSelector<MembershipState>(MembershipFeatureKey);
// All Membership
export const allPlansSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.allPlans;
  }
);
// All Cards
export const allCardsSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.allCards;
  }
);
// Delete Card
export const deleteCardSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.deleteCard;
  }
);
// Pay Membership
export const payMembershipSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.payMembership;
  }
);
// Add Card
export const addCardSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.addCard;
  }
);

/**
 * All Membership Selector
 */
export const allPlansSuccessSelector = createSelector(
  allPlansSelector,
  (state) => {
    return state.data;
  }
);
export const allPlansFailureSelector = createSelector(
  allPlansSelector,
  (state) => {
    return state.failure;
  }
);
export const allPlansLoadingSelector = createSelector(
  allPlansSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * All Cards Selector
 */
export const allCardsSuccessSelector = createSelector(
  allCardsSelector,
  (state) => {
    return state.data;
  }
);
export const allCardsFailureSelector = createSelector(
  allCardsSelector,
  (state) => {
    return state.failure;
  }
);
export const allCardsLoadingSelector = createSelector(
  allCardsSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Delete Card Selector
 */
export const deleteCardSuccessSelector = createSelector(
  deleteCardSelector,
  (state) => {
    return state.data;
  }
);
export const deleteCardFailureSelector = createSelector(
  deleteCardSelector,
  (state) => {
    return state.failure;
  }
);
export const deleteCardLoadingSelector = createSelector(
  deleteCardSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Pay Membership Selector
 */
export const payMembershipSuccessSelector = createSelector(
  payMembershipSelector,
  (state) => {
    return state.data;
  }
);
export const payMembershipFailureSelector = createSelector(
  payMembershipSelector,
  (state) => {
    return state.failure;
  }
);
export const payMembershipLoadingSelector = createSelector(
  payMembershipSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Add Card Selector
 */
export const addCardSuccessSelector = createSelector(
  addCardSelector,
  (state) => {
    return state.data;
  }
);
export const addCardFailureSelector = createSelector(
  addCardSelector,
  (state) => {
    return state.failure;
  }
);
export const addCardLoadingSelector = createSelector(
  addCardSelector,
  (state) => {
    return state.loading;
  }
);
// Update User Sub
export const updateUserMembershipSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.updateMembership;
  }
);
export const updateUserMembershipSuccessSelector = createSelector(
  updateUserMembershipSelector,
  (state) => {
    return state.data;
  }
);
export const updateUserMembershipFailureSelector = createSelector(
  updateUserMembershipSelector,
  (state) => {
    return state.failure;
  }
);
export const updateUserMembershipLoadingSelector = createSelector(
  updateUserMembershipSelector,
  (state) => {
    return state.loading;
  }
);
// Cancel Membershio
export const cancelMembershipSelector = createSelector(
  MembershipFeatureSelector,
  (state) => {
    return state.cancelMembership;
  }
);
export const cancelMembershipSuccessSelector = createSelector(
  cancelMembershipSelector,
  (state) => {
    return state.data;
  }
);
export const cancelMembershipFailureSelector = createSelector(
  cancelMembershipSelector,
  (state) => {
    return state.failure;
  }
);
export const cancelMembershipLoadingSelector = createSelector(
  cancelMembershipSelector,
  (state) => {
    return state.loading;
  }
);
